import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "centered-text"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Download File")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_button = _resolveComponent("el-button")

  return (_ctx.fetchState === _ctx.FetchStates.FETCHING)
    ? (_openBlock(), _createBlock("span", _hoisted_1, [
        _createVNode(_component_el_progress, {
          percentage: 100,
          indeterminate: true
        })
      ]))
    : (_openBlock(), _createBlock("span", _hoisted_2, [
        (_ctx.error)
          ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createBlock("span", _hoisted_4, [
              (_ctx.fileUrl == null)
                ? (_openBlock(), _createBlock("span", _hoisted_5, "No File Uploaded"))
                : (_openBlock(), _createBlock("span", _hoisted_6, [
                    (_ctx.isImage)
                      ? (_openBlock(), _createBlock("span", _hoisted_7, [
                          _createVNode("img", {
                            src: _ctx.fileUrl,
                            height: "200"
                          }, null, 8, ["src"]),
                          _createVNode("div", null, _toDisplayString(_ctx.fileName), 1)
                        ]))
                      : (_openBlock(), _createBlock("span", _hoisted_8, [
                          _createVNode("a", {
                            href: _ctx.fileUrl,
                            target: "_blank",
                            download: _ctx.fileName
                          }, [
                            _createVNode(_component_el_button, null, {
                              default: _withCtx(() => [
                                _hoisted_9,
                                _hoisted_10,
                                _createTextVNode(_toDisplayString(_ctx.fileName), 1)
                              ]),
                              _: 1
                            })
                          ], 8, ["href", "download"])
                        ]))
                  ]))
            ]))
      ]))
}